import React, { useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { handlePostRequest } from "../../services/PostTemplate";
import * as Yup from "yup";
import classNames from "classnames";
import { Calendar } from "primereact/calendar";
import ZbizInput from "../../components/zbizInput/ZbizInput";

const DateTimeSearch = ({ companyId, onFilter, lazyState }) => {
  const [loading, setloading] = useState(false);
  const [loadingIcon, setloadingIcon] = useState("");

  const validationSchema = Yup.object().shape({
    fromDateTime: Yup.date().nullable(),
    toDateTime: Yup.date().when("fromDateTime", (fromDateTime, schema) => {
      return fromDateTime !== null
        ? schema
            .min(
              fromDateTime,
              "To Date Time must be greater than From Date Time"
            )
            .required("This field is required.")
        : schema.nullable();
    }),
  });

  // Additional validation for fromDateTime
  // validationSchema.validateAt("fromDateTime", {}).catch(() => {});

  function formatDateToCustomFormat(date) {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed, so we add 1.
    const dd = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");
    const ss = String(date.getSeconds()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
  }

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      fromDateTime: null,
      toDateTime: null,
      ocrName: null,
      ocrFathername: null,
      ocrCnic: null,
      gateName: null,
    },
    onSubmit: async (data) => {
      try {
        const params = new URLSearchParams({
          page: lazyState.page,
          size: lazyState.rows,
        });
        const formattedData = {
          companyId: parseInt(companyId),
          time1: formik.values.fromDateTime
            ? formatDateToCustomFormat(formik.values.fromDateTime)
            : null,
          time2: formik.values.toDateTime
            ? formatDateToCustomFormat(formik.values.toDateTime)
            : null,
          ocrName: data["ocrName"] === "" ? null : data["ocrName"],
          ocrFathername:
            data["ocrFathername"] === "" ? null : data["ocrFathername"],
          ocrCnic: data["ocrCnic"] === "" ? null : data["ocrCnic"],
          gateName: data["gateName"] === "" ? null : data["gateName"],
        };
        setloading(true);
        setloadingIcon("pi pi-spin pi-spinner");
        const res = await handlePostRequest(
          formattedData,
          `gateLog/search?${params}`
        );
        setloading(false);
        setloadingIcon("pi pi-save");
        onFilter(res?.data, formattedData);
      } catch (error) {
        setloading(false);
        setloadingIcon("pi pi-save");
        onFilter(null);
      }
    },
  });
  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const props = {
    onChange: formik.handleChange,
    values: formik.values,
    isFormFieldValid: isFormFieldValid,
    getFormErrorMessage: getFormErrorMessage,
  };

  return (
    <div className="card Card__Round">
      <div className="Form__Header">
        <h1> Filter</h1>
      </div>
      <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
        <div className="p-fluid p-formgrid p-grid">
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <label
                htmlFor="fromDateTime"
                className={classNames(
                  { "p-error": isFormFieldValid("fromDateTime") },
                  "Label__Text"
                )}
              >
                From Date Time
              </label>
              <Calendar
                showTime
                hourFormat="12"
                placeholder="Enter From Date Time"
                name="fromDateTime"
                id="fromDateTime"
                value={formik.values.fromDateTime}
                onChange={formik.handleChange}
                className={classNames(
                  { "p-invalid": isFormFieldValid("fromDateTime") },
                  "Dropdown__Round"
                )}
              />
              {getFormErrorMessage("fromDateTime")}
            </div>
          </div>
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <label
                htmlFor="toDateTime"
                className={classNames(
                  { "p-error": isFormFieldValid("toDateTime") },
                  "Label__Text"
                )}
              >
                To Date Time
              </label>
              <Calendar
                showTime
                hourFormat="12"
                placeholder="Enter To Date Time"
                name="toDateTime"
                id="toDateTime"
                value={formik.values.toDateTime}
                onChange={formik.handleChange}
                className={classNames(
                  { "p-invalid": isFormFieldValid("toDateTime") },
                  "Dropdown__Round"
                )}
              />
              {getFormErrorMessage("toDateTime")}
            </div>
          </div>
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <ZbizInput label="Name" keyName="ocrName" {...props} />
            </div>
          </div>
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <ZbizInput
                label="Father Name"
                keyName="ocrFathername"
                {...props}
              />
            </div>
          </div>
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <ZbizInput label="CNIC" keyName="ocrCnic" {...props} />
            </div>
          </div>
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <ZbizInput label="Gate Name" keyName="gateName" {...props} />
            </div>
          </div>
        </div>

        <div className="Down__Btn">
          <Button
            disabled={loading}
            icon={loadingIcon || ""}
            iconPos="right"
            label={"Search"}
            className="Btn__Dark"
          />
        </div>
      </form>
    </div>
  );
};

export default DateTimeSearch;
